import { render, staticRenderFns } from "./minimize.vue?vue&type=template&id=22bcbc06&"
import script from "./minimize.vue?vue&type=script&lang=js&"
export * from "./minimize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports